export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "static/js/vdf.35c9f500.worker.js");
}
